import { RateLimiter } from "limiter";
import { StreamingHelper } from "@scrile/streaming-client";

export function initDebugInfo(WebRTC: StreamingHelper) {
  const parent = document.getElementsByClassName("go-live__wrapper-video")[0];
  const video = parent?.getElementsByTagName("video")[0];

  if (!parent || !video) {
    setTimeout(() => initDebugInfo(WebRTC), 1000);
    return;
  }

  let logContainer = document.getElementById("video_stats");
  if (!logContainer) {
    logContainer = document.createElement("div");
    logContainer.id = "video_stats";
    (logContainer.style as any) = "display: none; z-index: 10000; pointer-events: none; font-size: 5px; overflow: scroll; white-space: pre; color: white; position: absolute; padding-left: 5px; padding-bottom: 75px; left: 0; bottom: 0; width: 100%; height: 200px";
    parent.appendChild(logContainer);
  }

  let statsContainer = document.getElementById("webrtc_stats");
  if (!statsContainer) {
    statsContainer = document.createElement("div");
    statsContainer.id = "webrtc_stats";
    (statsContainer.style as any) = "display: none; z-index: 10000; pointer-events: none; font-size: 5px; overflow: scroll; white-space: pre; color: white; position: absolute; padding-left: 5px; padding-top: 55px; left: 0; top: 0; width: 100%";
    parent.appendChild(statsContainer);
  }

  function log(msg: string) {
    if (!logContainer) return;
    logContainer.innerText += msg + "\n";
  }

  function updateStats() {
    if (!statsContainer) return;
    statsContainer.innerText = WebRTC.getStatisticHistory(1)
      .consumer.rtcStatsChanges[0]?.stats.map((s: any) => JSON.stringify(s))
      .join(",\n");

    setTimeout(updateStats, 1000);
  }

  video.addEventListener("ended", () => log("ended"));
  video.addEventListener("abort", () => log("abort"));
  video.addEventListener("error", () => log("error"));
  video.addEventListener("pause", () => log("pause"));
  video.addEventListener("play", () => log("play"));
  video.addEventListener("playing", () => log("playing"));
  video.addEventListener("suspend", () => log("suspend"));

  updateStats();

  let debugVisible = false;
  let limiter = new RateLimiter({ tokensPerInterval: 10, interval: 3000 });
  document.body.addEventListener("click", () => {
    if (!limiter.tryRemoveTokens(1)) {
      if (!debugVisible) {
        logContainer && (logContainer.style.display = "block");
        statsContainer && (statsContainer.style.display = "block");
      } else {
        logContainer && (logContainer.style.display = "none");
        statsContainer && (statsContainer.style.display = "none");
      }
      debugVisible = !debugVisible;
      limiter = new RateLimiter({ tokensPerInterval: 10, interval: 3000 });
    }
  });
}
